import { ReactNode } from "react";
import { AdminSidebar } from "./AdminSidebar";
import { AdminThemeProvider, useAdminTheme } from "@/contexts/AdminThemeContext";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { Loader2 } from "lucide-react";

interface AdminLayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
}

function AdminLayoutContent({ children, title, description }: AdminLayoutProps) {
  const { theme } = useAdminTheme();
  const { loading, isAdmin } = useAdminAuth();

  if (loading) {
    return (
      <div className={`${theme} min-h-screen bg-background flex items-center justify-center`}>
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAdmin) {
    return null; // useAdminAuth redirects to /admin/login
  }

  return (
    <div className={`${theme} min-h-screen bg-background`}>
      <AdminSidebar />
      {/* Main content */}
      <main className="ml-64 p-8">
        <div className="max-w-6xl mx-auto">
          <div className="mb-6 lg:mb-8">
            <h1 className="font-display text-2xl lg:text-3xl font-bold text-foreground mb-1 lg:mb-2">{title}</h1>
            {description && (
              <p className="text-sm lg:text-base text-muted-foreground">{description}</p>
            )}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}

export function AdminLayout(props: AdminLayoutProps) {
  return (
    <AdminThemeProvider>
      <AdminLayoutContent {...props} />
    </AdminThemeProvider>
  );
}
